import { useUserStudioAccessQuery } from '../queries/use-user-studio-access-query';
import { useUserPublishAccessQuery } from '../queries/use-user-publish-access-query';

export const useUserPermissions = () => {
  const { data: studioAccess, isLoading: isStudioLoading } =
    useUserStudioAccessQuery();
  const { data: publishAccess, isLoading: isPublishLoading } =
    useUserPublishAccessQuery();

  return {
    studioAccess,
    publishAccess,
    isStudioLoading,
    isPublishLoading,
    // Combined flag preserved for callers that need both queries to settle.
    // Prefer the granular flags above when only one permission is consumed.
    isLoading: isStudioLoading || isPublishLoading,
  };
};
